import { useConversationPanelToggle } from "@circle-react-uikit/CircleAIAppShell/hooks/useConversationPanelToggle";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";
import type { PlanTiers } from "@/react/helpers/planHelpers";
import { planTiers } from "@/react/helpers/planHelpers";
import { usePlanPageVariant } from "@/react/hooks/usePlanPageVariant";

import { FeaturesList } from "../shared/FeaturesList";

const getGridClasses = (planTier: string, isTabLayout: boolean) => {
  const rowClasses = (() => {
    // Plus has 9 highlights and Business has 5; every other tier has 7 or 8.
    // Each tier's row count is set so its highlights split evenly across the 2
    // visible columns instead of overflowing into (or leaving empty space in)
    // a 3rd column.
    if (planTier === planTiers.plus) {
      return "md:grid-rows-5";
    }

    if (planTier === planTiers.business) {
      return "md:grid-rows-3";
    }

    return "md:grid-rows-4";
  })();

  const baseClasses = isTabLayout
    ? "grid grid-cols-1 gap-y-2"
    : "grid auto-cols-max grid-flow-col gap-x-10 gap-y-2";

  return classNames(baseClasses, rowClasses);
};

interface PlanFeaturesProps {
  containerClassName?: string;
  isOnOffer: boolean;
  planTier: PlanTiers;
  shouldHighlightFeatures: boolean;
  title?: string;
}

export const PlanFeatures = ({
  title,
  planTier,
  isOnOffer,
  shouldHighlightFeatures,
  containerClassName = "mt-2 px-0 sm:mt-6 sm:px-11",
}: PlanFeaturesProps) => {
  const { isCompactLayout, isMobileLayout } = usePlanPageVariant();
  const { isOpen: isAiPanelOpen } = useConversationPanelToggle();

  return (
    <div className={containerClassName}>
      <div>
        {title && (
          <div className="mb-2 sm:mb-4">
            <Typography.LabelXs weight="semibold">{title}</Typography.LabelXs>
          </div>
        )}
        <div
          className={getGridClasses(
            planTier,
            isCompactLayout || isMobileLayout || isAiPanelOpen,
          )}
        >
          <FeaturesList
            planTier={planTier}
            isOnOffer={isOnOffer}
            shouldHighlightFeatures={shouldHighlightFeatures}
          />
        </div>
      </div>
    </div>
  );
};
